import axios from "axios";
import {API} from "../env";
import Vuex from "@/store";

export default {
    /**
     * Contact us api
     * @param {object} data
     * @api {POST} api/web/addContactUs
     */
    contactUs(data){

        const option = {
            method: 'POST',
            url: API + 'api/web/addContactUs',
            header: {'content-type': 'application/json'},
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * Get training documents
     * @api {GET} api/web/getTrainingDocuments
     */
    getTrainingDocs(){

        const option = {
            method: 'GET',
            url: API + 'api/web/getTrainingDocuments',
            header: {'content-type': 'application/json'},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * Get about us
     * @api {GET} api/web/about
     */
    about(){
        const option = {
            method: 'GET',
            url: API + 'api/web/about',
            header: {'content-type': 'application/json'},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * Get all sponsors
     * @api {GET} api/web/getSponsor
     */
    getSponsors() {
        const option = {
            method: 'GET',
            url: API + 'api/web/getSponsor',
            header: {'content-type': 'application/json'},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    getHomeParagraphs() {
        const option = {
            method: 'GET',
            url: API + 'api/web/getStaticPages',
            header: {'content-type': 'application/json'},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    getHomeLeaderboard(mission_id) {
        const option = {
            method: 'GET',
            url: API + `api/web/homeLeaderboard/${mission_id}`,
            header: {'content-type': 'application/json'},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * Get user age
     * @api {GET} api/web/myMissions
     * @return {Promise} represents user age
     */
    getUSerType() {
        const option = {
            method: 'GET',
            url: API + 'api/web/myMissions',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    leaderboard(params) {
        const option = {
            method: 'GET',
            url: API + 'api/web/leaderBoared',
            header: {'content-type': 'application/json'},
            params: {...params}
        }

        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    getScores(){

        const option = {
            method: 'GET',
            url: API + 'api/web/myEvents',
            headers: {'content-type': 'application/json',  Authorization: 'Bearer ' + Vuex.getters.token},
        };


        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * get sub admin
     * @returns {Promise<unknown>}
     */
    getSubAdmin(){

        const option = {
            method: 'GET',
            url: API + 'api/web/subadmins',
            headers: {'content-type': 'application/json',  Authorization: 'Bearer ' + Vuex.getters.token},
        };


        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * get videos
     * @returns {Promise<unknown>}
     */
    videos(ip, page = 1){

        const option = {
            method: 'POST',
            url: API + 'api/web/01-space',
            // headers: {'content-type': 'application/json',  Authorization: 'Bearer ' + Vuex.getters.token},
            data: {
                ip: ip,
                page: page
            }
        };


        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

    /**
     * get videos
     * @returns {Promise<unknown>}
     */
     likeUnlikeVideo(video_id, ip){

        const option = {
            method: 'POST',
            url: API + 'api/web/01-space/like',
            // headers: {'content-type': 'application/json',  Authorization: 'Bearer ' + Vuex.getters.token},
            data: {
                video_id: video_id,
                ip: ip,
            }
        };


        return new Promise((resolve, reject) => {
            axios(option)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        })
    },

}